$(function(){
	$('.nav-internal').each(function(){
		var intNav = $(this),
			intNavItems = intNav.find('a'),
			$intNav = false;
		if(intNavItems.first().offset().top != intNavItems.last().offset().top){
			// Breaking over 2 lines
			$intNav = intNav.find('ul').flickity({
				pageDots:false,
				cellAlign:'center',
				prevNextButtons:false,
				contain:true,
				freeScroll:true,
				draggable:true,
				imagesLoaded:true
			});
		}
		body.on('scrolld',function(){
			if(intNav.offset().top <= 0){
				intNav.addClass('stuck')
			} else{
				intNav.removeClass('stuck')
			}
			// SET ACTIVE STATES ON SCROLL
			intNav.find('a').each(function(i){
				var target = $(this).attr('href').split('#')[1],
					section = $('#'+target)
					$this = $(this);
				if(section.offset().top < $(window).height()*0.33){
					intNav.find('a').removeClass('active');
					$this.addClass('active');
				}
				if($intNav && i == intNavItems.length - 1){
					$intNav.flickity('select',intNav.find('a.active').parent().index());
				}
			});
		});
		intNav.find('a').click(function(event){
			event.preventDefault();
			var target = $(this).attr('href').split('#')[1];
			document.getElementById(target).scrollIntoView({ 
			  behavior: 'smooth' 
			});
		});
	});
});